var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('em')])
}
var staticRenderFns = []

export { render, staticRenderFns }